// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__O0Bdd","left":"StickyBox_left__r45Br","right":"StickyBox_right__3SQXO"};